const toStringValue = value => String(value == null ? '' : value).trim()

export function extractApiErrorMessage(error, fallbackMessage = 'Не удалось выполнить запрос.') {
  const message =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.response?.data?.data ||
    error?.message

  const normalized = toStringValue(message)
  return normalized || fallbackMessage
}

export function unwrapListResponse(data) {
  if (Array.isArray(data)) return data
  if (Array.isArray(data?.content)) return data.content
  if (Array.isArray(data?.items)) return data.items
  return []
}

export function unwrapPageResponse(data, fallbackPage = 0, fallbackSize = 20) {
  const content = unwrapListResponse(data)
  const totalElements = Number(data?.totalElements)
  const totalPages = Number(data?.totalPages)
  const pageNumber = Number(data?.number)
  const pageSize = Number(data?.size)

  return {
    content,
    totalElements: Number.isFinite(totalElements) ? totalElements : content.length,
    totalPages: Number.isFinite(totalPages) ? totalPages : (content.length ? 1 : 0),
    page: Number.isFinite(pageNumber) ? pageNumber : Number(fallbackPage) || 0,
    size: Number.isFinite(pageSize) ? pageSize : Number(fallbackSize) || 20,
  }
}

export function parseJsonInput(value, { allowEmpty = true, allowAnyJson = false } = {}) {
  const text = toStringValue(value)
  if (!text) {
    return {
      isValid: Boolean(allowEmpty),
      value: null,
      error: allowEmpty ? '' : 'Поле обязательно.',
    }
  }

  try {
    const parsed = JSON.parse(text)
    if (!allowAnyJson && (parsed == null || Array.isArray(parsed) || typeof parsed !== 'object')) {
      return {
        isValid: false,
        value: null,
        error: 'Ожидается JSON-объект.',
      }
    }
    return {
      isValid: true,
      value: parsed,
      error: '',
    }
  } catch (error) {
    return {
      isValid: false,
      value: null,
      error: `Невалидный JSON: ${error?.message || 'ошибка синтаксиса.'}`,
    }
  }
}

export function stringifyJsonInput(value) {
  if (value == null) return ''
  if (typeof value === 'string') {
    const raw = toStringValue(value)
    if (!raw) return ''
    try {
      return JSON.stringify(JSON.parse(raw), null, 2)
    } catch {
      return raw
    }
  }
  if (typeof value === 'object') return JSON.stringify(value, null, 2)
  return ''
}

export function formatDateTime(value) {
  const raw = toStringValue(value)
  if (!raw) return '—'
  const date = new Date(raw)
  if (Number.isNaN(date.getTime())) return raw
  return date.toLocaleString('ru-RU')
}

export function normalizeSearchText(value) {
  return toStringValue(value).toLowerCase()
}
